import {IReduxRoutesState} from '../../@interfaces';

const state: IReduxRoutesState = {
	apiRoutesLoaded: false,
	clientRoutesLoaded: false,
	apiRoutes: [],
	clientRoutes: [],
};

export default state;
